import { getTargetKey } from 'utils/key-util';

export default {
  expectedKey({ progress }, g, rs, rootGetters) {
    const { currentText, currentIndex } = progress;

    if (!rootGetters['activity/currentRound']) return '';

    switch (currentText[currentIndex]) {
      case '\n':
        return 'enter';
      case '\t':
        return 'tab';
      default:
        return currentText[currentIndex];
    }
  },

  isFreeTextTyping({ isFreeTextTyping }) {
    return isFreeTextTyping;
  },

  isEndOfCurrentText({ progress }) {
    const { currentText, currentIndex } = progress;
    return currentIndex === currentText.length;
  },

  isEndOfCurrentWord(_, getters) {
    return getters.isEndOfCurrentText;
  },

  isEndOfCurrentSentence(_, getters) {
    return getters.isEndOfCurrentText;
  },

  isEndOfRound(_, { isEndOfCurrentText }, rootState, rootGetters) {
    return rootGetters['activity/isLastStepInRound'] && isEndOfCurrentText;
  },

  isTouchHold(state, getters, { activity }, rootGetters) {
    const [round] = activity.rounds;
    const { characters } = activity.data.keyboard || {};
    const restrictedCharacters = characters && characters.length < 26;

    const numbers = '0123456789'.split('');
    const hasNumbers = (characters || '').split('').some(ch => numbers.includes(ch));
    const isOnScreenKb = rootGetters['application/ipadWithoutExternalKeyboard'];
    if (activity.data.type === 'PaintedFingerClue' && hasNumbers && isOnScreenKb) {
      return false;
    }

    if (round.isTouchHold !== undefined) {
      return round.isTouchHold;
    }

    return restrictedCharacters;
  },

  targetKey(state, getters, { activity }, rootGetters) {
    const round = rootGetters['activity/currentRound'];
    // Sometimes CMS sends touch and hold restricted keys here
    const { characters } = activity.data.keyboard || {};
    return round?.targetKey || round?.shiftKey || getTargetKey(characters);
  }
};
